module.exports = __webpack_public_path__ + "static/img/liyade3.606d9229.jpg";